( function( app ) {
  const COMPONENT = {
    init: function() {
      function titleHeight( element ) {
        const links = $( element ).find( '.image-card__link' );
        const cards = $( element ).find( '.image-card' );
        let maxHeight = 73;
        $( links ).each( function() {
          const h = $( this ).outerHeight(); // or height()
          maxHeight = Math.max( maxHeight, $( this ).outerHeight() );
        } );

        $( cards ).each( function() {
          this.style.setProperty( '--title-height', maxHeight + 'px' );
        } );
      }
      if ( $( '.image-column-cards' ).length ) {
        $( '.image-column-cards' ).each( function( index, element ) {
          titleHeight( element );
        } );
        const resizeThrottle = new app.components.common.Throttle( () => this.titleHeight(), 250 );
        $( window ).on( 'resize', () => resizeThrottle.run() );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-column-cards', COMPONENT );
} )( app );
